import 'selectize/dist/js/standalone/selectize.js'

$(function() {
    $('.selectize').selectize();
});



// WEBPACK FOOTER //
// ./app/assets/granite/js/selectize.js